import { memo, useCallback, useState } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { Button } from "ui/components/Button/Button";

import { PasswordInfoCardProps } from "./types";
import PasswordEditCard from "./components/PasswordEditCard/PasswordEditCard";

const PasswordInfoCard: React.FC<PasswordInfoCardProps> = () => {
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const handleEditClick = useCallback(() => {
    setShowEditModal(true);
  }, []);

  const handleEditSuccess = useCallback(() => {
    setShowEditModal(false);
  }, []);

  const handleEditClose = useCallback(() => {
    setShowEditModal(false);
  }, []);

  return (
    <>
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px] ">
          <div>
            <p className="text-base font-bold text-slate-600 py-3">
              Lozinka
            </p>
            <p className="text-sm">
              Promijenite lozinku za pristup vašem računu.
            </p>
          </div>
        </div>
        <div className="flex justify-between items-center flex-1 px-3 my-3">
          <div className="flex flex-col min-w-[530px]">
            <div className="mb-3">
              <TextField
                type="password"
                name="password"
                label="Lozinka"
                placeholder=""
                value="••••••••"
                cssClassName="bg-white"
                disabled
              ></TextField>
            </div>
          </div>
          <div>
            <Button
              variant="outlined"
              children="Uredi"
              onClick={handleEditClick}
              startIcon="/media/icons/plus.svg"
            />
          </div>
        </div>
      </div>
      <PasswordEditCard
        show={showEditModal}
        onSuccess={handleEditSuccess}
        onClose={handleEditClose}
      />
    </>
  );
};

export default memo(PasswordInfoCard);
